export enum AlertKey {
    backendErrorMessage = "backend-error-message",
    topupSuccess = "topup-success",
    contractRemoveSuccess = "contract-removed",
    contractCreateSuccess = "contract-created",
    contractGroupCreateSuccess = "contract-group-created",
    campaignTakeOfflineSuccess = "campaign-take-offline-success",
    campaignProductTakeOfflineSuccess = "campaign-product-take-offline-success",
    "campaignCopyProductsContractsDeletedWarning" = "campaign-copy-contract-warning",
    campaignOrderSuccess = "campaign-order-success",
    campaignCopySuccess = "campaign-copy-success",
    campaignSaveSuccess = "campaign-save-success",
    buttonCopySuccess = "copy-button-success",
    productAddToBasket = "add-product-to-basket-success",
    productRemoveFromBasket = "remove-product-from-basket-warning",
    utmCodeConfirmation = "utm-code-confirmation",
}

export enum AlertType {
    "success" = "success",
    "info" = "info",
    "warning" = "warning",
    "error" = "error",
    "custom" = "custom",
}
